import { render, staticRenderFns } from "./array.vue?vue&type=template&id=40a5f860"
import script from "./array.vue?vue&type=script&lang=ts"
export * from "./array.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports